import { namespace } from 'vuex-class';
import { IDirectoryState } from '@/content-library/directories/store/directory.types';

export const Directories = namespace('contentLibrary/directories');

export const state: IDirectoryState = {
  loading: false,
  loaded: false,
  directories: [],
  breadcrumbs: [],
};

export enum EDirectoryAction {
  Load = 'load',
  LoadSuccess = 'loadSuccess',
  LoadFailed = 'loadFailed',
  UpdateDirectory = 'updateDirectory',
  UpdateBreadcrumbs = 'updateBreadcrumbs',
  RemoveDirectory = 'removeDirectory',
  AddDirectory = 'addDirectory',
  ResetState = 'resetState',
}

export enum EDirectoryMutation {
  SetState = 'setState',
  SetLoading = 'setLoading',
  SetLoaded = 'setLoaded',
  SetDirectories = 'setDirectories',
  SetBreadcrumbs = 'setDirectoryPath',
}
